import assignments from "../imgs/assignments.png";
import asgmt0 from "./2023_asgmt_handouts/handout_0.pdf";
import asgmt1 from "./2023_asgmt_handouts/handout_1.pdf";
import asgmt2 from "./2023_asgmt_handouts/handout_2.pdf";
import asgmt3 from "./2023_asgmt_handouts/handout_3.pdf";
import asgmt4 from "./2023_asgmt_handouts/handout_4.pdf";
import asgmt5 from "./2023_asgmt_handouts/handout_5.pdf";
import asgmt6 from "./2023_asgmt_handouts/handout_6.pdf";
import final from "./2023_asgmt_handouts/handout_final.pdf";
import { Link } from "react-scroll";
function AssignmentsPage() {
  return (
    <div className="assignments-page">
      <div className="assignments">
        <img className="assignments-img" src={assignments} alt="Assignment Header"></img>
      </div>
      <div className="assignments-desc">
        <p>
          All projects are due at 11:59pm Eastern on the listed date. Read more about the grading policy in the{" "}
          <b>
            <Link activeClass="active" smooth spy to="resources-page">
              Resources
            </Link>
          </b>{" "}
          section.
        </p>
      </div>
      <div className="table-wrapper">
        <table className="assignments-table">
          <tr>
            <th width="20%"> Project </th>
            <th width="5%"> Release </th>
            <th width="5%"> Due </th>
            <th width="10%"> Intermediate Submission (if any) </th>
            <th width="10%"> Gear Up </th>
          </tr>
          <tr>
            <td>
              <a href={asgmt0}> Install Assignment </a>
            </td>
            <td> 9/7 </td>
            <td> 9/12 </td>
            <td></td>
            <td>N/A</td>
          </tr>
          <tr>
            <td>
              <a href={asgmt1}> Search </a>
            </td>
            <td> 9/12 </td>
            <td> 9/19 </td>
            <td></td>
            <td>
              <a
                href="https://docs.google.com/presentation/d/1K9BvCXikKCFtJckMVw4A2OEBOwcI79YPsAefBOPdHq8/edit?usp=sharing"
                target="_blank"
              >
                <div>slides</div>
              </a>
              <a
                href="https://drive.google.com/file/d/1iWzCLw9ksf_ahXv9yZetOelSz2xGOmdH/view?usp=sharing"
                target="_blank"
              >
                <div>recording</div>
              </a>
            </td>
          </tr>
          <tr>
            <td>
              {" "}
              <a href={asgmt2}> Adversarial Search </a>{" "}
            </td>
            <td> 9/20 </td>
            <td> 9/27 </td>
            <td> </td>
            <td>
              <a
                href="https://docs.google.com/presentation/d/1fF4LPLSPq29Yb60dzTD8D_pKSMBZrQGNaEsagS5W50E/edit?usp=sharing"
                target="_blank"
              >
                <div>slides</div>
              </a>
              <a
                href="https://drive.google.com/file/d/1rwzJRqfXiNpkyRq1WVno8oqvxv4GN_1H/view?usp=sharing"
                target="_blank"
              >
                <div>recording</div>
              </a>
              <a href="https://edstem.org/us/courses/44858/discussion/3465127" target="_blank">
                <div>guideline</div>
              </a>
            </td>
          </tr>
          <tr>
            <td>
              {" "}
              <a href={asgmt3}> KRR </a>{" "}
            </td>
            <td> 9/28</td>
            <td> 10/5</td>
            <td> </td>
            <td>
              <a href="https://drive.google.com/file/d/1GFRHJ7rqLEOMo-xifVzPqWcXb-xL7QE4/view" target="_blank">
                <div>slides</div>
              </a>
              <a
                href="https://brown.zoom.us/rec/share/-F3-dMnYwPgNKt9LpMBDKGCGDCL2SYf46EOfif9S7ozITlcM3q22mZxZ3TuutsTM.qXlSOvQrQ6xeksrl?startTime=1696021216000"
                target="_blank"
              >
                <div>recording</div>
              </a>
            </td>
          </tr>
          <tr>
            <td>
              {" "}
              <a href={asgmt4}> HMM </a>{" "}
            </td>
            <td> 10/12 </td>
            <td>10/26 </td>
            <td> 10/19 </td>
            <td>
              <a
                href="https://docs.google.com/presentation/d/1WN6f7NKFwEOkry4T0sDj1yAjWgc4rLnolRZfbMSuvpg/edit?usp=sharing"
                target="_blank"
              >
                <div>slides</div>
              </a>
              <a
                href="https://drive.google.com/file/d/1xJggojiugWR-l8FYv7y7JmAPFSB3uYwW/view?usp=sharing"
                target="_blank"
              >
                <div>recording</div>
              </a>
              <a href="https://edstem.org/us/courses/44858/discussion/3622518" target="_blank">
                <div>guideline</div>
              </a>
            </td>
          </tr>
          <tr>
            <td>
              {" "}
              <a href={asgmt5}> Reinforcement Learning </a>{" "}
            </td>
            <td> 10/27 </td>
            <td> 11/7 </td>
            <td></td>
            <td>
              
            </td>
          </tr>
          <tr>
            <td> 
              {" "}
              <a href={asgmt6}> Supervised Learning </a>{" "}
            </td>
            <td> 11/8 </td>
            <td> 11/20 </td>
            <td> </td>
            <td>
            <a href="https://docs.google.com/presentation/d/117FsYyQ_SbiGLUwKj3AGF_GyljlYWB5Qy6ngsCV7nRk/edit?usp=sharing" target="_blank">
                <div>Slides</div>
              </a>
              <a href="https://drive.google.com/file/d/12-47ljUKtzN-hwGzGpmakbJS3W3B0Xzf/view?usp=sharing" target="_blank">
                <div>Recording</div>
              </a>
              <a href="https://edstem.org/us/courses/44858/discussion/3826295" target="_blank">
                <div>guideline</div>
              </a>
            </td>
          </tr>
          <tr>
            <td>
              {" "}
              <a href={final}> Final Project </a>{" "}
            </td>
            <td> 10/13 </td>
            <td> 12/18 </td>
            <td> Refer to handout </td>
            <td></td>
          </tr>
        </table>
      </div>
    </div>
  );
}

export default AssignmentsPage;
